import React, { useContext, useEffect } from 'react';
import PortableWindow from '../PortableWindow/PortableWindow';
import CentumTabs from '../Tabs/CentumTab';
import EqualizeComponent from './components/EqualizeComponent/EqualizeComponent';
import FunctionKeysComponent from './components/FunctionKeysComponent/FunctionKeysComponent';
import OperationMarkComponent from './components/OperationMarkComponent/OperationMarkComponent';
import MultimediaComponent from './components/MultimediaComponent/MultimediaComponent';
import BrowserBarComponent from './components/BrowserBarComponent/BrowserBarComponent';
import TrendComponent from './components/TrendComponent/TrendComponent';
import StationComponent from './components/StationComponent/StationComponent';
import PrinterComponent from './components/PrinterComponent/PrinterComponent';
import BuzzerComponent from './components/BuzzerComponent/BuzzerComponent';
import DisplayComponent from './components/DisplayComponent/DisplayComponent';
import WindowSwitchComponent from './components/WindowSwitchComponent/WindowSwitchComponent';
import AlarmComponent from './components/AlarmComponent/AlarmComponent';
import PresetMenuComponent from './components/PresetMenuComponent/PresetMenuComponent';
import CentumButton from '../Button/CentumButton';
import './sh-setup.css';
import { Context, ShConfig } from '../../ContextVP';

export interface ShSettings {
    config: any;
    updateConfig: (conf: any) => void;
}
interface IShSetup {
    index: number;
    item: any;
    CloseSettings: () => void;
    SelectActiveTab: (id: number) => void;
}

function ShSetup(props: IShSetup) {
    const { index, item, CloseSettings, SelectActiveTab } = props;

    const [config, setConfig] = React.useState(useContext(Context)?.shConfig);

    const tabGroups = [
        {
            title: 'Group 1',
            tabs: [
                { title: 'Equalize' },
                { title: 'Function Keys' },
                { title: 'Operation Mark' },
                { title: 'Multimedia' },
                { title: 'Browser Bar' },
                { title: 'Trend' }
            ]
        },
        {
            title: 'Group 2',
            tabs: [
                { title: 'Station' },
                { title: 'Printer' },
                { title: 'Buzzer' },
                { title: 'Display' },
                { title: 'Window Switch' },
                { title: 'Alarm' },
                { title: 'Preset Menu' }
            ]
        }
    ];

    const updateConfig = (conf: ShConfig) => {
        setConfig((prevConfig) => {
            return { ...prevConfig, ...conf };
        });
    };

    type TabKey = keyof typeof tabComponents;
    const [selectedTab, setSelectedTab] = React.useState<TabKey | ''>('Station');

    const tabComponents = {
        Equalize: <EqualizeComponent />,
        'Function Keys': <FunctionKeysComponent />,
        'Operation Mark': <OperationMarkComponent />,
        Multimedia: <MultimediaComponent />,
        'Browser Bar': <BrowserBarComponent />,
        Trend: <TrendComponent />,
        Station: <StationComponent />,
        Printer: <PrinterComponent />,
        Buzzer: <BuzzerComponent />,
        Display: <DisplayComponent config={config} updateConfig={updateConfig} />,
        'Window Switch': <WindowSwitchComponent />,
        Alarm: <AlarmComponent />,
        'Preset Menu': <PresetMenuComponent />
    };

    function ApplyConfig(config: any) {
        localStorage.setItem('ShSettings', JSON.stringify(config));
    }

    function SaveAndClose(config: any) {
        localStorage.setItem('ShSettings', JSON.stringify(config));
        CloseSettings();
    }

    const handleMouseClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (!item.active) SelectActiveTab(index);
    };

    return (
        <div onMouseDown={handleMouseClick}>
            <PortableWindow
                active={item.active}
                width={650}
                height={600}
                Top={0}
                Left={0}
                title=".SH HIS SETUP"
                OnClose={CloseSettings}>
                <div style={{ padding: '20px 5px 5px 5px' }}>
                    <div style={{ padding: '0px 5px' }}>
                        <CentumTabs
                            tabGroups={tabGroups}
                            selectedTab={(title: string) => {
                                setSelectedTab(title as TabKey);
                            }}
                        />
                    </div>

                    {selectedTab ? <div className="main-setup-container">{tabComponents[selectedTab]}</div> : <></>}
                    <div className="buttons-container">
                        <CentumButton
                            name={'OK'}
                            onClick={() => SaveAndClose(config)}
                            style={{ height: '25px', width: '80px' }}
                        />
                        <CentumButton name={'Cancel'} style={{ height: '25px', width: '80px' }} />
                        <CentumButton
                            name={'Apply'}
                            onClick={() => ApplyConfig(config)}
                            style={{ height: '25px', width: '80px' }}
                        />
                        <CentumButton name={'Help'} style={{ height: '25px', width: '80px' }} />
                    </div>
                </div>
            </PortableWindow>
        </div>
    );
}

export default ShSetup;
